import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMoreNavIcon(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M10.34 9c.6 0 1.09.49 1.09 1.09 0 .6-.49 1.09-1.09 1.09-.6 0-1.09-.49-1.09-1.09 0-.6.49-1.09 1.09-1.09Zm0-1.25C9.05 7.75 8 8.8 8 10.09c0 1.29 1.05 2.34 2.34 2.34 1.29 0 2.34-1.05 2.34-2.34 0-1.29-1.04-2.34-2.34-2.34ZM10.34 15.75c.6 0 1.09.49 1.09 1.09 0 .6-.49 1.09-1.09 1.09-.6 0-1.09-.49-1.09-1.09 0-.6.49-1.09 1.09-1.09Zm0-1.25C9.05 14.5 8 15.55 8 16.84c0 1.29 1.05 2.34 2.34 2.34 1.29 0 2.34-1.05 2.34-2.34 0-1.29-1.04-2.34-2.34-2.34ZM10.34 2.25c.6 0 1.09.49 1.09 1.09 0 .6-.49 1.09-1.09 1.09-.6 0-1.09-.49-1.09-1.09 0-.6.49-1.09 1.09-1.09Zm0-1.25C9.05 1 8 2.05 8 3.34c0 1.29 1.05 2.34 2.34 2.34 1.29 0 2.34-1.05 2.34-2.34 0-1.29-1.04-2.34-2.34-2.34Z",
    fill: "currentColor"
  }));
}

export { SvgMoreNavIcon as default };
